import { useAutocomplete } from '@material-ui/lab';
import {
  CUISINES_LABEL,
  POPULAR_SEARCHES_TEXT,
  RESTAURANTS_LABEL,
} from '../../../assets/copy';
import { useItemsInMarket } from '../../../utils/useItemsInMarket';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import {
  handleCuisineSelect,
  handleSearchSelect,
  handleVenueSelect,
  useSearchRedirect,
} from '../../search/helpers';
import { stripDiacritics } from '../../../utils/stripDiacritics';
import { trackClickWithDescription } from '../../../utils/useOneTag';

const trackPopularSearches = ({ name, elementType, elementDescription }) => {
  trackClickWithDescription(name, elementType, elementDescription);
};

export const SEARCH_TRACK_MAX_LENGTH = 2;
export const DEBOUNCE_MILLISECONDS = 500;

export const goToSearchPage = (history) => {
  history?.push('/search');
};

export const onSearchChange = (
  reason,
  details,
  marketId,
  filters,
  dispatch,
  history,
  redirectTo
) => {
  goToSearchPage(history);

  switch (reason) {
    case 'select-option':
      switch (details.option.type) {
        case POPULAR_SEARCHES_TEXT:
        case CUISINES_LABEL:
          handleCuisineSelect(details.option, dispatch);
          trackPopularSearches({
            name: `search-revamp-popular-searches-link`,
            elementType: 'Link',
            elementDescription: `${details.option.name} ${CUISINES_LABEL} - ${POPULAR_SEARCHES_TEXT}`,
          });
          goToSearchPage();
          break;
        case RESTAURANTS_LABEL:
          handleVenueSelect(details.option, history);
          trackPopularSearches({
            name: `search-revamp-restaurant-search-link`,
            elementType: 'Link',
            elementDescription: `${details.option.name} ${RESTAURANTS_LABEL} - ${POPULAR_SEARCHES_TEXT}`,
          });
          break;
        default:
          break;
      }
      break;
    case 'create-option':
      handleSearchSelect(details.option, dispatch, true);
      goToSearchPage();
      break;
    default:
      break;
  }
};

export const useCuisineAndRestaurantSearch = (overrideDefaultProps = {}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const redirectTo = useSearchRedirect();
  const { market } = useSelector((state) => state.markets);
  const { currentFilters } = useSelector((state) => state.filters);
  const { venues, cuisines } = useItemsInMarket();
  return useAutocomplete({
    id: 'cuisine-and-restaurant-search-bar',
    freeSolo: true,
    filterOptions: (options, { inputValue }) => {
      if (!inputValue) {
        return options.filter(
          (option) => option.type === POPULAR_SEARCHES_TEXT
        );
      }

      const pattern = new RegExp(`\\b${inputValue}`, 'gi');
      return options.filter(
        (option) =>
          option.type !== POPULAR_SEARCHES_TEXT &&
          (pattern.test(option.name) ||
            pattern.test(stripDiacritics(option.name)))
      );
    },
    options: [
      ...cuisines.map((cuisine) => ({
        ...cuisine,
        type: POPULAR_SEARCHES_TEXT,
      })),
      ...cuisines.map((cuisine) => ({ ...cuisine, type: CUISINES_LABEL })),
      ...venues.map((venue) => ({ ...venue, type: RESTAURANTS_LABEL })),
    ],
    getOptionLabel: (option) => option.name ?? '',
    groupBy: (option) => option.type,
    onChange: (_, __, reason, details) =>
      onSearchChange(
        reason,
        details,
        market.id,
        currentFilters,
        dispatch,
        history,
        redirectTo
      ),
    ...overrideDefaultProps,
  });
};
